import { HStack, HStackTypes } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { Text, Pressable, Flex } from 'native-base';
import React from 'react';

import { CustomerItemTagObject } from '../../../../utils/types';

interface ItemTagTriggerButtonTextProps extends HStackTypes.Props {
  children: React.ReactNode;
}

interface ItemTagTriggerButtonProps {
  tags: CustomerItemTagObject[];
  triggerProps?: any;
  onOpen: () => void;
  isListing?: boolean;
}

const gapStyle = { gap: 4 };

const ItemTagTriggerButtonText: React.FC<ItemTagTriggerButtonTextProps> = ({
  children,
  ...rest
}) => {
  return (
    <HStack
      {...rest}
      alignItems="center"
      bg={'feedback.gen.lightest'}
      px={Spacing['inline.nano']}
      py={Spacing['inline.quarck']}
      borderRadius={BoxRadius.xs}>
      <Text
        flex={1}
        numberOfLines={1}
        color="brand.tertiary.dark"
        variant="semibold"
        fontSize={Typography['fontsize.md']}>
        {children}
      </Text>
    </HStack>
  );
};

export const ItemTagTriggerButton: React.FC<ItemTagTriggerButtonProps> = ({
  tags,
  triggerProps,
  onOpen,
  isListing = false,
}) => {
  if (!tags?.length) {
    return (
      <Pressable {...triggerProps} onPress={!isListing ? onOpen : null}>
        <Text color="brand.tertiary.dark" variant="semibold" fontSize={Typography['fontsize.md']}>
          {isListing ? 'NENHUMA TAG' : 'ADD TAG'}
        </Text>
      </Pressable>
    );
  }

  const firstItemLable = tags[0].tagName;

  const itemCount = tags.reduce((acc, _, index) => {
    if (index > 0) {
      acc += 1;
    }
    return acc;
  }, 0);

  return (
    <Pressable {...triggerProps} onPress={onOpen}>
      <Flex style={gapStyle} flexWrap="wrap" flexDirection="row">
        <ItemTagTriggerButtonText maxW={{ base: '170px', sm: 'full', lg: '100px' }}>
          {firstItemLable}
        </ItemTagTriggerButtonText>
        {itemCount > 0 && <ItemTagTriggerButtonText>+{itemCount}</ItemTagTriggerButtonText>}
        {!isListing && <ItemTagTriggerButtonText>+</ItemTagTriggerButtonText>}
      </Flex>
    </Pressable>
  );
};
